export const deliveredGalRegEx = /^\d{1,5}(\.\d{1,2})?\.?$/;

export const decimalNumberRegex = /^\d{1,5}(?:\.\d{1,5})?$/;

// matches integers, decimals, just a dot, but not empty string
export const flexibleDecimalRegex = /^(?:\d+(\.\d+)?|\.\d+)$/;

export const leadingDigitRegex = /^\d/;
export const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
// export const phoneNumberRegex = /^\+?[1-9]\d{1,14}$/;
export const phoneNumberRegex = /^\+[0-9]{0,15}$/;

export const whitespaceRegex = /\s/g;

export const delimiterRegex = /[;,]/;

//validates integers or decimal number
export const numberRegex = /^\d+$/;

export const regexDecimalUpToFive = /^\d*\.?\d{0,5}$/;

/**
 * Regular expression to validate a domain prefix.
 *
 * - Matches strings that start with a lowercase letter, followed by any combination of lowercase letters, digits, hyphens or punycode.
 **/
export const domainPrefixRegex = /^([a-z][a-z\d]*(-[a-z\d]+)*|xn--[-a-z\d]+)$/i;

export const zoneRegex = /^(10|\d)$/;

export const MAX_NUMBER_LIMIT_REGEX = /^\d{1,5}(\.\d{1,2}|\.)?$|^$/;
export const RATE_LIMIT_FOR_LOADING_ORDER = /^\d{1,5}(\.\d{1,5}|\.)?$|^$/;
export const RATE_LIMIT_FOR_DELIVERY_ORDER = /^\d{1,5}(\.\d{1,5}|\.)?$|^$/;
export const RATE_LIMIT_FOR_DELIVERY_ORDER_BILLING_RATE = /^\d{1,5}(\.\d{1,4}|\.)?$|^$/;
export const RATE_LIMIT_FOR_EXTRACTION_ORDER = /^\d{1,5}(\.\d{1,5}|\.)?$|^$/;
